import { forwardRef } from '@chakra-ui/react';

import { Box, type BoxProps } from '@frontend/components';

import { useTableStyles } from '../TableStylesContext';

export type TableFooterProps = BoxProps;

/**
 * A Table subcomponent used to contain elements below the Table's grid.
 * - Place within the Table after the TableHeader and TableContent.
 * - Wraps a Chakra-UI Box and responds to Table's size.
 */
export const TableFooter = forwardRef<TableFooterProps, 'div'>(
  ({ children, ...restProps }, ref) => {
    const { footer: footerStyles } = useTableStyles() ?? {};

    return (
      <Box ref={ref} __css={footerStyles} {...restProps}>
        {children}
      </Box>
    );
  },
);
TableFooter.displayName = 'TableFooter';
